import { render, staticRenderFns } from "./PrivacyProtocol.vue?vue&type=template&id=3ed82e3e&scoped=true"
import script from "./PrivacyProtocol.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocol.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocol.vue?vue&type=style&index=0&id=3ed82e3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed82e3e",
  null
  
)

export default component.exports